import { render, staticRenderFns } from "./ClientsComponent.vue?vue&type=template&id=fd3a2c4e&scoped=true&"
import script from "./ClientsComponent.vue?vue&type=script&lang=js&"
export * from "./ClientsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3a2c4e",
  null
  
)

export default component.exports